/**
 * Discover top-of-page vertical spacing (QA-17 item 3).
 *
 * Kelly ("Rework wasted space above") -> Gordon 2026-08-11 ("trim the wasted
 * padding above; KEEP the slim 'Discover' wordmark"). The centered content
 * wrapper in ExploreV2/index.jsx previously carried `py: { xs: 1.5, md: 3 }`
 * (12px / 24px top AND bottom). That top padding, stacked on top of the wordmark
 * Stack's own margin and the app header, was the "wasted space above" the feed.
 *
 * The fix trims ONLY the TOP padding (the wordmark itself is kept, per Gordon),
 * leaving the bottom rhythm intact so the controls below don't crowd the hero.
 * Extracted here as a pure contract so the trim is asserted in CI (jsdom does no
 * layout), the same way exploreGridWrapperSx.js guards the feed's height floor.
 *
 * Do not restore `pt` to the old { xs: 1.5, md: 3 } — that reintroduces the gap.
 */

/** Trimmed TOP padding above the Discover wordmark (MUI spacing units). */
export const DISCOVER_WRAPPER_PT = { xs: 0.75, md: 1 };

/** Unchanged BOTTOM padding (keeps the pre-QA-17 vertical rhythm below). */
export const DISCOVER_WRAPPER_PB = { xs: 1.5, md: 3 };
